/* eslint-disable import/extensions */

import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { useFormikContext } from 'formik'

import customerInfoSchema, {
  companySchema,
} from '../components/CustomerInfoForm/CustomerInfoForm.schemas'
import { fetchClientExists } from '../store/customer.reducer'
import {
  selectDocIdTovalidate,
  selectClientExistsLoading,
  selectDoesClientExist,
  selectDocTypeToValidate,
  selectIsEnterprise,
} from '../store/customer.selectors'

import { selectIsCartera } from '~/sale/store'
import { selectTheme } from '~/ui'

export default function useClientExistsValidation() {
  const { setStatus, status } = useFormikContext()
  const brand = useSelector(selectTheme)
  const docId = useSelector(selectDocIdTovalidate)
  const isCartera = useSelector(selectIsCartera)
  const dispatch = useDispatch()
  const isClientExistsLoading = useSelector(selectClientExistsLoading)
  const doesClientExist = useSelector(selectDoesClientExist)
  const docType = useSelector(selectDocTypeToValidate)
  const isEnterprise = useSelector(selectIsEnterprise)

  useEffect(() => {
    if (!isCartera) validate()
  }, [docId])

  useEffect(() => {
    const error = doesClientExist ? 'Debes realizar la venta como cliente existente' : ''
    setStatus({
      ...status,
      docId: {
        loading: isClientExistsLoading,
        error,
      },
    })
  }, [isClientExistsLoading, doesClientExist])

  // @TODO Move this to a common place
  function mapYupToFormikErrors(err: { inner: any[] }) {
    return err.inner
      .filter((i: { message: any }) => !!i.message)
      .reduce(
        (curr: any, next: { path: any; errors: any[] }) => ({
          ...curr,
          [next.path]: next.errors[0],
        }),
        {},
      )
  }

  function validateSchema(values: unknown, schema: any) {
    return schema
      .validate(values, {
        abortEarly: false,
        strict: false,
      })
      .then(() => {
        return {}
      })
      .catch(mapYupToFormikErrors)
  }

  async function validate() {
    const schemaField: string = isEnterprise ? 'cif' : 'docId'
    const schema = isEnterprise ? companySchema : customerInfoSchema(false)
    const errors = await validateSchema({ [schemaField]: docId }, schema)

    if (!errors[schemaField]) {
      dispatch(fetchClientExists({ value: docId, tenant: brand, validationType: docType }))
    }
  }
}
